import { Injectable } from "@angular/core";
import { I18nService } from "src/app/shared/i18n/service/i18n.service";
import { SnackBarModel, SNACKBAR_CLASS } from "../model/snackbar.model";
import { SnackbarComponent } from "../snackbar.component";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
  providedIn: "root",
})
export class SnackbarService {
  constructor(
    public snackBar: MatSnackBar,
    private i18n: I18nService
  ) { }

  openSnackBar(data: SnackBarModel, duration?: number): void {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: data,
      panelClass: data.type,
      verticalPosition: "top",
      horizontalPosition: "end",
      duration: !!duration ? duration : 5000,
    });
  }


  openSnackReferClassWithoutTranslate(
    message: string,
    type: SNACKBAR_CLASS
  ): void {
    const snackData: any = {};
    snackData.message = message;
    snackData.type = type;
    this.openSnackBar(snackData);
  }

  openSnackReferClassWithoutTranslatewithTimeOut(
    message: string,
    type: SNACKBAR_CLASS,
    duration?:number
  ): void {
    const snackData: any = {};
    snackData.message = message;
    snackData.type = type;
    this.openSnackBar(snackData,duration);
  }

  openSnackReferClassWithTranslationEmbedded(
    message: string,
    type: SNACKBAR_CLASS
  ): void {
    const snackData: any = {};
    snackData.message = this.i18n.getTranslation(message);
    snackData.type = type;
    this.openSnackBar(snackData);
  }
}
